module.exports = "<div class=\"tabs-content\" [ngClass]=\"{'is-content-active':active}\">\r\n  <ng-content></ng-content>\r\n</div>"